import { PurchaseOrderStatus } from "./enums/purchase-order-status.enum";

export const purchaseOrderStatusLabels=[
{
    key:PurchaseOrderStatus.Draft.toString(),
    textClass: 'text-blue-600',
    bgClass: 'bg-blue-600/10',
},
,{
    key:PurchaseOrderStatus.WaitingForSalesManApproval.toString(),
    textClass: 'text-indigo-600',
    bgClass: 'bg-indigo-600/10',
},
{
    key:PurchaseOrderStatus.Placed.toString(),
    textClass: 'text-green-500',
    bgClass: 'bg-green-500/10',
},
{
    key:PurchaseOrderStatus.PartiallyPosted.toString(),
    textClass: 'text-green-600',
    bgClass: 'bg-green-600/10',
},{
    key:PurchaseOrderStatus.Posted.toString(),
    textClass: 'text-emerald-600',
    bgClass: 'bg-emerald-600/10',
},
{
    key:PurchaseOrderStatus.Synced.toString(),
    textClass: 'text-yellow-600',
    bgClass: 'bg-yellow-600/10',
},
{
    key:PurchaseOrderStatus.RejectedBySalesAgent.toString(),
    textClass: 'text-red-600',
    bgClass: 'bg-red-600/10',
},
 ]